import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {SalesJournalSearchPageComponent} from "./sales-journal/sales-journal-search-page/sales-journal-search-page.component";
import {CashManagementSearchPageComponent} from "./cash-management/cash-management-search-page/cash-management-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {SalesJournalEditPageComponent} from "./sales-journal/sales-journal-edit-page/sales-journal-edit-page.component";
import {ReasonCodeSearchPageComponent} from "./reason-code/reason-code-search-page/reason-code-search-page.component";
import {ReasonCodeEditPageComponent} from "./reason-code/reason-code-edit-page/reason-code-edit-page.component";
import {ReasonCodeTypeSelectOptionsComponent} from "./reason-code/controls/reason-code-type-select-options.component";
import {ConsolidationReportComponent} from "./reports/consolidation-report/consolidation-report.component";
import {BalanceTillSummaryReportComponent} from "./reports/balance-till-summary-report/balance-till-summary-report.component";
import {BalanceTillBreakdownReportComponent} from "./reports/balance-till-breakdown-report/balance-till-breakdown-report.component";
import {BestWorstSellersReportComponent} from "./reports/best-worst-sellers-report/best-worst-sellers-report.component";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {ProductSaleAuditReportComponent} from "./reports/product-sale-audit-report/product-sale-audit-report.component";
import {DetailedSalesReportComponent} from "./reports/detailed-sales-report/detailed-sales-report.component";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {CashManagementEditPageComponent} from "./cash-management/cash-management-edit-page/cash-management-edit-page.component";
import {CashManagementEditCashCalcComponent} from "./cash-management/cash-management-edit-page/cash-management-edit-cash-calc/cash-management-edit-cash-calc.component";
import {CashManagementVerifyBalanceSearchActionComponent} from "./cash-management/actions/cash-management-verify-balance-search-action.component";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {PriceLevelAuditReportComponent} from "./reports/price-level-audit-report/price-level-audit-report.component";
import {VoidAuditReportComponent} from "./reports/void-audit-report/void-audit-report.component";
import {SalesByHalfHourReportComponent} from "./reports/sales-by-half-hour-report/sales-by-half-hour-report.component";
import {SalesByHourReportComponent} from "./reports/sales-by-hour-report/sales-by-hour-report.component";
import {SalesByPaymentTypeReportComponent} from "./reports/sales-by-payment-type-report/sales-by-payment-type-report.component";
import {SalesAuditReportComponent} from "./reports/sales-audit-report/sales-audit-report.component";
import {ProductSaleCostingReportComponent} from "./reports/product-sale-costing-report/product-sale-costing-report.component";
import {SurchargeAuditReportComponent} from "./reports/surcharge-audit-report/surcharge-audit-report.component";
import {OpenItemReportComponent} from "./reports/open-item-report/open-item-report.component";
import {DiscountAuditReportComponent} from "./reports/discount-audit-report/discount-audit-report.component";
import {BasketAnalysisReportComponent} from "./reports/basket-analysis-report/basket-analysis-report.component";
import {BriefTillSummaryReportSearchActionComponent} from "./cash-management/actions/brief-till-summary-report-search-action.component";
import {ErrorCorrectReportPageComponent} from "./reports/error-correct-report/error-correct-report-page.component";
import {ExtraSalesSummaryReportPageComponent} from "./reports/extra-sales-summary-report/extra-sales-summary-report-page.component";
import {TabReportComponent} from "./reports/tab-report/tab-report.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {TableReportComponent} from "./reports/table-report/table-report.component";
import {OrderHistoryAuditReportComponent} from "./reports/order-history-audit-report/order-history-audit-report.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";
import {SaleSharedModule} from "./sale.shared.module";
import {SalesJournalPaymentRefundComponent} from "./sales-journal/sales-journal-edit-page/sales-journal-payment-refund.component";
import {ProductsSoldReportComponent} from "./reports/products-sold-report/products-sold-report.component";
import {ExtrasSoldReportComponent} from "./reports/extras-sold-report/extras-sold-report.component";
import {SalesByCategoryReportComponent} from "./reports/sales-by-category-report/sales-by-category-report.component";
import {ReconciliationReportComponent} from "./reports/reconciliation-report/reconciliation-report.component";

@NgModule({
    imports: [SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        PosSharedModule,
        CatalogueSharedModule,
        EmployeeSharedModule,
        PricingSharedModule,
        CustomObjectSharedModule,
        SaleSharedModule
    ],
    declarations: [
        SalesJournalSearchPageComponent,
        CashManagementSearchPageComponent,
        CashManagementEditPageComponent,
        SalesJournalEditPageComponent,
        SalesJournalPaymentRefundComponent,
        ReasonCodeSearchPageComponent,
        ReasonCodeEditPageComponent,
        CashManagementEditCashCalcComponent,
        CashManagementVerifyBalanceSearchActionComponent,
        BriefTillSummaryReportSearchActionComponent,
        ReasonCodeTypeSelectOptionsComponent,
        ConsolidationReportComponent,
        ReconciliationReportComponent,
        BalanceTillSummaryReportComponent,
        BalanceTillBreakdownReportComponent,
        BestWorstSellersReportComponent,
        BasketAnalysisReportComponent,
        ProductSaleAuditReportComponent,
        DetailedSalesReportComponent,
        ErrorCorrectReportPageComponent,
        ExtraSalesSummaryReportPageComponent,
        PriceLevelAuditReportComponent,
        OrderHistoryAuditReportComponent,
        VoidAuditReportComponent,
        SalesByCategoryReportComponent,
        SalesByHalfHourReportComponent,
        SalesByHourReportComponent,
        SalesByPaymentTypeReportComponent,
        SalesAuditReportComponent,
        ProductSaleCostingReportComponent,
        SurchargeAuditReportComponent,
        OpenItemReportComponent,
        DiscountAuditReportComponent,
        TabReportComponent,
        TableReportComponent,
        ProductsSoldReportComponent,
        ExtrasSoldReportComponent
    ],
    exports: [
        SalesJournalSearchPageComponent,
        CashManagementSearchPageComponent,
        CashManagementEditPageComponent,
        CashManagementEditCashCalcComponent,
        CashManagementVerifyBalanceSearchActionComponent,
        BriefTillSummaryReportSearchActionComponent,
        SalesJournalEditPageComponent,
        ReasonCodeSearchPageComponent,
        ReasonCodeEditPageComponent,
        ReasonCodeTypeSelectOptionsComponent,
        ConsolidationReportComponent,
        ReconciliationReportComponent,
        BalanceTillSummaryReportComponent,
        BalanceTillBreakdownReportComponent,
        BestWorstSellersReportComponent,
        BasketAnalysisReportComponent,
        ProductSaleAuditReportComponent,
        DetailedSalesReportComponent,
        ErrorCorrectReportPageComponent,
        ExtraSalesSummaryReportPageComponent,
        PriceLevelAuditReportComponent,
        OrderHistoryAuditReportComponent,
        VoidAuditReportComponent,
        SalesByCategoryReportComponent,
        SalesByHalfHourReportComponent,
        SalesByHourReportComponent,
        SalesByPaymentTypeReportComponent,
        SalesAuditReportComponent,
        ProductSaleCostingReportComponent,
        SurchargeAuditReportComponent,
        OpenItemReportComponent,
        DiscountAuditReportComponent,
        TabReportComponent,
        TableReportComponent,
        ProductsSoldReportComponent,
        ExtrasSoldReportComponent
    ]
})

export class SaleModule {
}
